import React, { useEffect, useState } from 'react';
import { Gift, Users, Zap } from 'lucide-react';
import { apiClient } from '../api';

const ReferralsCard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    apiClient.get('/referrals/me')
      .then((r) => setStats(r.data))
      .catch((err) => console.debug('Referrals load failed:', err?.message));
  }, []);

  if (!stats) return null;

  const { total_referrals, credited, boost_credits } = stats;
  const hasAny = total_referrals > 0 || boost_credits > 0;

  return (
    <div
      className="bg-gradient-to-r from-fnl-pink/15 to-purple-500/15 border border-fnl-pink/40 rounded-2xl p-5 mb-6"
      data-testid="referrals-card"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-fnl-pink/20 flex items-center justify-center shrink-0">
          <Gift className="w-5 h-5 text-fnl-pink" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-white font-bold text-lg">Invite friends, earn free boosts</div>
          <div className="text-purple-300 text-xs mt-0.5 mb-3">
            Share your profile link. Each friend who joins gets you a free Boost — no cooldown.
          </div>
          <div className="flex flex-wrap items-center gap-4 mt-2">
            <div className="flex items-center gap-1.5">
              <Users className="w-4 h-4 text-purple-300" />
              <span className="text-white font-bold" data-testid="referrals-total">
                {total_referrals}
              </span>
              <span className="text-purple-300 text-xs">
                friend{total_referrals === 1 ? '' : 's'} invited
              </span>
            </div>
            <div className="flex items-center gap-1.5">
              <Zap className="w-4 h-4 text-yellow-300" />
              <span className="text-white font-bold" data-testid="referrals-credits">
                {boost_credits}
              </span>
              <span className="text-purple-300 text-xs">
                free boost{boost_credits === 1 ? '' : 's'} earned
              </span>
            </div>
          </div>
          {hasAny && credited < total_referrals && (
            <div className="text-yellow-200/85 text-[11px] mt-3">
              {total_referrals - credited} pending — credit unlocks once your friend completes their profile.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReferralsCard;
